



class DocumentRequest {
  constructor() {
    this.user_Id=null;
    this.type=null; 
    this.documentStatus=null;
    this.userId =null;
    this.mobileNumber =null;
    this.isApproved =null;
    this.updatedBy =null;
    this.contact =null;
    this.isEmail =null;
    this.isPhone =null;
    
  
   

  }}
  export default DocumentRequest;